import { apiClient, apiClientAuth } from "../http/httpClient";


export function ProductApi(contentType = "application/json")
{
    const http = apiClient(contentType);
    const https = apiClientAuth(contentType);

    return {

       /**
        * @route   POST /api/products
        * @desc    Créer un nouveau produit avec images optionnelles
        * @access  Private (Authentifié)
        * @middleware upload.array('images', 5) - Traite jusqu'à 5 images
        * @middleware validateCreateProduct - Valide les données du produit
        * @middleware handleValidationErrors - Gère les erreurs de validation
        */
        insert : (product) => https.post("/api/products", product), 

       /**
        * @route   GET /api/products
        * @desc    Récupérer tous les produits avec images et utilisateur associé
        * @access  Private (Authentifié)
        */
        findAll : () => https.get(`/api/products`),

       /**
        * @route   GET /api/products/count/category
        * @desc    Récupérer le comptage des produits par catégorie
        * @access  Private (Authentifié)
        * @note    Cette route doit être placée AVANT la route /:id pour éviter les conflits
        */
        getCount : () => https.get(`/api/products/count/category`),

       /**
        * @route   GET /api/products/best-sellers
        * @desc    Récupérer les 12 produits les plus commandés (best sellers)
        * @access  Private (Authentifié)
        * @note    Cette route doit être placée AVANT la route /:id pour éviter les conflits
        * @returns {Object} Array de 12 produits triés par nombre total de commandements
        *   - totalOrders: nombre total de commandes pour ce produit
        *   - totalRevenue: revenu total généré par ce produit
        */
        getBestSeller : () => https.get(`/api/products/best-sellers`),
        
       /**
        * @route   PUT /api/products/:id
        * @desc    Mettre à jour un produit existant avec l'email du modérateur
        * @access  Private (Authentifié)
        * @param   {integer} id - Identifiant du produit
        * @middleware upload.array('images', 5) - Optionnel: ajouter de nouvelles images
        * @middleware validateUpdateProduct - Valide les données à mettre à jour
        * @middleware handleValidationErrors - Gère les erreurs de validation
        */
        update: (id, product) => https.put(`/api/products/${id}`, product),

        /**
        * @route   GET /api/products/:id
        * @desc    Récupérer un produit spécifique avec ses images et créateur
        * @access  Public
        * @param   {integer} id - Identifiant du produit
        */
        findOne: (id) => http.get(`/api/products/${id}`),


    };
}

